export const jira = {
  issueTypes: {
    bug: 'bug',
    story: 'story',
  },
};
export default jira;
